<div class="tmp-section-item-wrapper">
    <span class="tmp-section-title">{{title()}}</span>

    <!-- <div class="range-slider">
        <input type="range" [max]="1440 - step" [min]="0" [step]="step" (touchend)="valueChange()"
            (mouseup)="valueChange()" [(ngModel)]="min" />
        <input type="range" [max]="1440" [min]="step" [step]="step" (touchend)="valueChange()" (mouseup)="valueChange()"
            [(ngModel)]="max" />
    </div>
    <div style="display: flex;align-items: center;justify-content: space-between;padding: 7px 3px;">
        <span>{{min > 0 ? transformMinute(min) : '00:00'}}</span>
        <span>{{max < 1440 ? transformMinute(max) : '23:59' }}</span>
    </div> -->

    <div class="slider-container">
        <div class="slider-track"></div>
        <div class="range" [ngStyle]="{'left': minPercent() + '%', 'width': rangeWidth() + '%'}"></div>

        <input type="range" [min]="min()" [max]="max()" [step]="step()" [value]="minValue_t()" #minValuet
            (input)="updateRange(minValuet.value, maxValuet.value)" (change)="sendValue()" />

        <input type="range" [min]="min()" [max]="max()" [step]="step()" [value]="maxValue_t()" #maxValuet
            (input)="updateRange(minValuet.value, maxValuet.value)" (change)="sendValue()" />

    </div>
    <div class="valuewrapper">
        <span>{{minValue_t() > 0 ? transformMinute(minValue_t()) : '00:00'}}</span>
        <span>{{maxValue_t() < 1440 ? transformMinute(maxValue_t()) : '23:59' }}</span>
    </div>
</div>